import { regen } from "../utils/axios";


export const sendMessage = async (payload) => {
  const url = `/messageCenter/send`;
  const { data } = await regen.post(url, payload);
  return data;
};

export const getMessages = async (accountId, page = 1, perPage = 10) => {
  const url = `/users/message/${accountId}?perPage=${perPage}&page=${page}`;
  const { data } = await regen.get(url);
  return data;
};

export const getConnectionList = async (messageId) => {
  const url = `/messages/users`;
  const { data } = await regen.get(url);
  return data;
};

export const blockUser = async (payload) => {
  const { accountId, information, reason } = payload;
  const url = `/message/block/${accountId}`;
  const { data } = await regen.post(url, { information, reason });
  return data;
}

export const unblockUser = async (accountId) => {
  const url = `message/unblock/${accountId}`;
  const { data } = await regen.post(url);
  return data;
};

export const unReadMessage = async (messageId) => {
  const url = `/messages/${messageId}/unread`;
  const { data } = await regen.post(url);
  return data;
};

export const readMessage = async (messageId) => {
  const url = `/messages/${messageId}/read`;
  const { data } = await regen.post(url);
  return data;
};